<template>
  <b-container>
    <b-modal v-model="promptVisible" title="提示" ok-only>{{ prompt }}</b-modal>

    <b-breadcrumb :items="bread" class="mt10"></b-breadcrumb>
    <b-card header="共享航次计划信息管理系统" header-tag="header" align="center" header-class="login-header"
      class="form-background">
      <b-row no-gutters style="padding:20px;">
        <div class="form-style">
          <h3 style="font-weight: bold">找回密码</h3>

          <b-form @submit="onSubmit" class="mt20">

            <b-form-group id="input-group-2" label="电子邮箱" label-for="input-2" :description="selectedEmailDescription">
              <b-form-input id="email" autocomplete="off" v-model="form.email" required type="email"></b-form-input>
            </b-form-group>

            <b-form-group id="input-group-2" label="用户名" label-for="input-2">
              <b-form-input id="username" autocomplete="off" v-model="form.username" required></b-form-input>
            </b-form-group>



            <b-form-group>
              <b-checkbox v-model="showFindEmail" style="font-weight: bolder;">
                我忘记账号了
              </b-checkbox>
            </b-form-group>

            <b-form-group v-if="showFindEmail" id="input-group-2" label="真实姓名" label-for="input-2"
              description="输入注册时填写的真实姓名，系统会帮你查找账号。">
              <b-input-group class="mt-3">
                <b-form-input id="realName" autocomplete="off" v-model="realName" required></b-form-input>
                <b-input-group-append>
                  <b-button variant="info" @click="findEmailByRealName">查找邮箱账号</b-button>
                </b-input-group-append>
              </b-input-group>

              <b-list-group v-if="findEmailItems.length > 0">
                <b-list-group-item class="d-flex justify-content-left align-items-center" v-for="item in findEmailItems"
                  @click="selectEmailItem(item)">
                  <b-radio v-model="selectedEmailItem" :value="item" style="margin-right: 20px;"></b-radio>
                  <span style="width: 200px;">用户名: {{ item.username }}</span>
                  <span>邮箱: {{ item.email }}</span>
                </b-list-group-item>
              </b-list-group>
            </b-form-group>

            <b-row
              style="display:flex;justify-content:space-between; padding:0 20px; font-size:16px;margin-bottom:40px;">
              <div>
                不用找了？
                <a href="/login">去登录</a>
              </div>
            </b-row>

            <b-button :disabled="commiting" block type="submit" variant="primary"
              style="padding:6px 80px; background-color:#0582bb;border:1px solid #006ea7">
              <b-spinner v-if="commiting" small style="margin-right:20px"></b-spinner>提交信息
            </b-button>
          </b-form>
        </div>
      </b-row>
    </b-card>
    <!-- LINKS -->
    <link-component class="mt20"></link-component>
  </b-container>
</template>

<script>
import LinkComponent from '../../components/LinkComponent.vue';
import { axiosServer } from '@/api/judge';
import { urls } from '@/api/urls';

export default {
  components: { LinkComponent },
  name: 'option',
  props: {},
  computed: {
    selectedEmailDescription() {
      return this.selectedEmailItem.email + ", 您需要补全邮箱并手动填写。";
    }
  },

  data() {
    return {
      bread: [
        {
          text: '首页',
          href: '/index'
        },
        {
          text: '找回密码'
        }
      ],
      form: {
        username: ''
      },
      commiting: false,
      prompt: '',
      promptVisible: false,
      realName: '',
      showFindEmail: false,
      findEmailItems: [],
      selectedEmailItem: {
        email: '',
        username: ''
      }
    };
  },

  mounted() { },

  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      this.commiting = true;
      axiosServer({
        url: urls.SvpFindPassword,
        params: this.form,
        type: 'post'
      })
        .then(resp => {
          this.commiting = false;
          if (resp.data.code == 0) {
            this.prompt = '您的密码将发送到您的邮箱，请注意查收';
            this.promptVisible = true;
            this.$nextTick(() => {
              this.$router.push({ name: 'ChiefScientistExplain' });
            });
          } else {
            this.showSubitError('操作失败 ：【 ' + resp.data.msg + ' 】');
          }
        })
        .catch(() => {
          this.commiting = false;
          this.showSubitError('操作失败，【未知原因】，请重新提交或联系管理员');
        });
    },
    showSubitError(msg) {
      this.prompt = msg;
      this.promptVisible = true;
    },
    findEmailByRealName() {

      this.findEmailItems = [];

      axiosServer({
        url: "/SvpFindPassword/findEmailAndAcountByName",
        params: { realName: this.realName },
        type: 'get'
      })
        .then(resp => {
          if (resp.data.code == 0) {
            this.findEmailItems = resp.data.data;
          } else {
            this.showSubitError(resp.data.msg);
          }
        })
        .catch(() => {
          this.showSubitError('操作失败，【未知原因】，请重新提交或联系管理员');
        });
    },
    selectEmailItem(item) {
      this.form.username = item.username;
      this.selectedEmailItem = item;
    }
  }
};
</script>

<style scoped>
.login-header {
  font-size: 20px;
  font-weight: bold;
  color: #115ca5;
}

@media (max-width: 575.99px) {
  .form-style {
    text-align: left;
    width: 100%;
  }

  .botton-row {
    margin-bottom: 20px;
  }
}

@media (min-width: 576px) {
  .form-style {
    text-align: left;
    width: 100%;
  }

  .botton-row {
    margin-bottom: 20px;
  }
}

@media (min-width: 768px) {
  .form-style {
    text-align: left;
    width: 70%;
    margin: 0 auto;
  }

  .botton-row {
    margin-bottom: 20px;
    padding: 0 50px;
  }
}

@media (min-width: 992px) {
  .form-style {
    text-align: left;
    width: 70%;
    margin: 0 auto;
  }

  .botton-row {
    margin-bottom: 20px;
    padding: 0 100px;
  }
}

@media (min-width: 1200px) {
  .form-style {
    text-align: left;
    width: 70%;
    margin: 0 auto;
  }

  .botton-row {
    margin-bottom: 20px;
    padding: 0 200px;
  }
}
</style>
